<template>
    <transition-group
        tag="ul"
        class="md-10"
        style="margin-right:2.5rem"
        enter-active-class="duration-150 ease-out"
        enter-class="opacity-0 scale-95"
        enter-to-class="opacity-100 scale-100"
        leave-active-class="duration-100 ease-in"
        leave-class="opacity-100 scale-100"
        leave-to-class="opacity-0 scale-95"
    >
    <li  v-for="(product, index) in products" v-bind:key="index">
      <div class="block focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
        <div class="flex items-center py-2">
          <div class="min-w-0 flex-auto flex items-center">
            <div class="min-w-0 flex-auto">
              <div>
                <div>
                  <span class="text-sm leading-5 font-medium text-indigo-600 truncate">{{ product.name }}</span>
                  <span class="truncate text-xs leading-5 text-gray-500"> x {{ product.quantity }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-auto text-right">
            <div class="md:block">
              <div>
                <div class="text-sm leading-5 text-gray-900" v-if="product.quantity > 1">{{ ((product.unit_amount * product.quantity) / 1000).toFixed(3)}} OMR</div>
                <div class="text-sm leading-5 text-gray-900" v-if="product.quantity <= 1">{{ (product.unit_amount / 1000).toFixed(3)}} OMR</div>
                <div class="mt-1 text-xs leading-5 text-gray-500" v-if="product.quantity > 1">
                  {{ (product.unit_amount/ 1000).toFixed(3) }} OMR each
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
    <li id="total-sm" class="border-t border-gray-200" v-bind:key="1000">
      <div class="block focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out">
        <div class="flex items-center py-2">
          <div class="min-w-0 flex-1 flex items-center">
            <div class="min-w-0 flex-1 md:grid md:grid-cols-2 md:gap-4">
              <div>
                <div>
                  <span class="text-sm leading-5 font-bold text-gray-800 truncate">Total</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-1 text-right">
            <div class="md:block">
              <div>
                <div class="text-sm font-bold leading-5 text-gray-900">{{ (totalAmount/1000).toFixed(3)}} OMR</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </li>
    </transition-group>
</template>

<script>
export default {
  name: 'ProductList',
  props: {
    products: Array,
    totalAmount: Number
  }
}
</script>
